import { CalendarView } from '../components/CalendarView';

export function Calendar() {
  return <CalendarView />;
}

